import { Box, Container, IconButton, Typography } from "@mui/material";
import React from "react";
import "react-responsive-iframe-viewer/dist/style.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import { getColor } from "../../style/color/color";
import { fonts } from "../../style/fonts/fonts";

const WebViewComponent = ({ url, setOpen }) => {
  const zoomLevel = window.innerWidth < 768 ? 1 : 1;

  return (
    <>
      {url && (
        <Box
          sx={{
            width: "100%",
            height: "100vh",
          }}
        >
          <Container
            sx={{
              flexGrow: 1,
            }}
          >
            {" "}
            <Box
              sx={{
                display: "flex",
                mt: "5px",
                mr: 4,
              }}
            >
              <IconButton sx={{ p: 0 }} onClick={() => setOpen(false)}>
                <ArrowBackIcon
                  fontSize="medium"
                  sx={{
                    mt: "10px",
                    color: getColor.PrimaryWoodSmoke,
                  }}
                />
              </IconButton>

              <Typography
                sx={{
                  color: getColor.black,
                  fontSize: "20px",
                  fontFamily: fonts.manrope,
                  fontWeight: 700,
                  mt: "11px",
                  ml: "7px",
                }}
              >
                {String.AccountAggregator.shareAccount}
              </Typography>
            </Box>
            <LinearProgressBar
              progress={62}
              stepNumber={"3"}
              progressNumber={62}
            />
          </Container>

          <iframe
            src={url}
            title="Dyanamic Iframe"
            allowFullScreen
            style={{
              width: "100%",
              height: "100%",
              maxHeight: "700px",
              border: "none",
              marginBottom: "20px",
              position: "fixed",
              transform: `scale(${zoomLevel})`, // Adjust the scale factor as needed
              transformOrigin: "0 0",
            }}
          ></iframe>
        </Box>
      )}
    </>
  );
};

export default WebViewComponent;
